import useFlag from 'lane-shared/hooks/useFlag';
import { FeatureFlag } from 'constants-flags';

export function useBuildingManagementOfTenantRoles() {
  const isEnabled = useFlag<boolean>(FeatureFlag.BuildingManagementTenantRoles, false);

  return Boolean(isEnabled);
}

